
import ProductBase from "@/common/ProductBase.vue";

export default {
  extends: ProductBase,

  props: {
    product: {
      type: Object,
      required: true,
    },

    eager: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      type: "card",
    };
  },
};
